import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";

import LayawaysTable from "./LayawaysTable";

const ModalPreviousLayaways = ({ open, onCloseModal }) => {
  return (
    <Dialog
      open={open}
      // onClose={onCloseModal}
      aria-labelledby={"error-success-dialogue"}
      maxWidth="md"
      sx={{ borderRadius: ".5rem" }}
    >
      <DialogTitle id={"error-success-title"} p={1}>
        Historial de Apartado
        <IconButton
          aria-label="close"
          onClick={onCloseModal}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box width={"75vw"}>
          <LayawaysTable />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPreviousLayaways;
